export default "__VITE_ASSET__BCDFV4If__"